'use client';

import { useSiteSettings } from '@/components/providers';
import { ConsentText } from '@/features/consent';

const DEFAULT_CONSENT_TEXT =
    'Zum Schutz vor Spam nutzen wir Google reCAPTCHA. Es wird erst mit Klick auf den Button geladen; dabei werden Daten wie Ihre IP-Adresse an Google übertragen, auch in die USA. Weitere Informationen finden Sie in unserer [privacy].';
const DEFAULT_CONSENT_BUTTON_TEXT = 'Captcha einblenden';
const REQUIRED_HINT = 'Das Formular kann erst nach dem Einblenden des Captchas abgesendet werden.';
/** Stands in for the hidden badge (forms.css), as Google requires when hiding it. */
const PROTECTED_NOTICE = 'Dieses Formular ist durch Google reCAPTCHA geschützt.';

type Props = {
    granted: boolean;
    required: boolean;
    onAccept: () => void;
    privacyPageSlug?: string;
};

/** Captcha slot of a form: 2-click consent like the YouTube overlay, the reCAPTCHA notice once granted. */
export function FormCaptcha({ granted, required, onAccept, privacyPageSlug }: Props) {
    const { captcha, privacySettings } = useSiteSettings();

    return (
        <div aria-live="polite" className="text-sm">
            {granted ? (
                <p>{PROTECTED_NOTICE}</p>
            ) : (
                <div className="flex flex-col items-start gap-4 bg-white/5 p-4">
                    <p className="whitespace-pre-line">
                        <ConsentText
                            text={captcha?.consentText ?? DEFAULT_CONSENT_TEXT}
                            privacyPageSlug={privacyPageSlug ?? privacySettings?.privacyPage?.slug}
                        />
                    </p>
                    <button type="button" onClick={onAccept} className="btn btn-primary-outline">
                        {captcha?.consentButtonText ?? DEFAULT_CONSENT_BUTTON_TEXT}
                    </button>
                    {required && <p className="text-xs">{REQUIRED_HINT}</p>}
                </div>
            )}
        </div>
    );
}
